<template lang="pug" >
.areaComments
    b-button( class="primary-button-xs responder" @click="showCommentBox") responder
    .mb-md( v-if="commentbox")
            b-message( v-for="message in messages") {{ message.name }} 
                .messageText( v-html="message.text" )
            .is-flex
                at-ta( class="textarea" v-model="message" :members="tags")
                    textarea
                button.sendButton( @click="onSubmit") enviar
</template>
<script>
import { currentUser } from '../mixins/user';
import { addCommentMessage } from '../services/services';
import AtTa from 'vue-at/dist/vue-at-textarea'
export default {
    name:"AreaComments",
    components:{
        AtTa,
    },
    props:{
        filteredTags:{
            type: Object,
        },
        records: null,
        idQuotation:{
            type: String,
        }, 
        idComment:{
            type: Number,
        }
    },
    data(){
        return{
            commentbox: false,
            tags: [],
            message:"",
            messages: [],
            selectedTags:[],
        }
    },
    methods: {
        showCommentBox(){
            this.commentbox = !this.commentbox;
            this.filteredTags.data.forEach( filteredTag => {
                this.tags.push( filteredTag.first_name );
            })
        },
        onSubmit(){
            this.messages.push({
                name: currentUser(),
                text: this.message,
            })
            const arrayMessage = this.message.split(" ");
            const arraySelectedTags = arrayMessage.forEach( wordMessage => {
                const firstChar = wordMessage.charAt(0);
                if(firstChar == "@"){
                    const tag = wordMessage.slice(1);
                    this.selectedTags.push(tag);
                }
            })
            const recipient_ids=[];
            this.filteredTags.data.forEach( tagObj => {
                this.selectedTags.forEach( TagName => {
                    if( tagObj.first_name == TagName ){
                        recipient_ids.push(tagObj.id)
                    }
                })
            })
            const data = {
                text: this.message,
                recipient_ids,
            }
            addCommentMessage(this.idQuotation, this.idComment, data).then( result=>{
            })
            this.message = ""
        },
    }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
@import '../assets/scss/spacing.scss'; 
    .textarea{
        min-width: 80%;
        min-height: 57px !important;
        textarea{
            border: none;
            outline: none;
            width: 100%;
            height: 100%;
        }
    }
    .sendButton{
        align-items: center;
        border: 1px solid $orange;
        border-radius: 5px;
        background-color: $orange;
        color: #ffffff;
        display: flex;
        font-weight: bold;
        justify-content: center;
        padding: 0 20px;
    }
    .responder {
        margin-bottom: 10px;
    }
</style>